var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnclaimedRewards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.61 40H4.39c-.818 0-1.48-.663-1.48-1.482v-23.89H37.09v23.89c0 .819-.663 1.482-1.48 1.482z",
    fill: "#FFC73B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFB025",
    d: "M2.908 14.628h34.183V19.6H2.908z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 9.446v6.158a1.19 1.19 0 0 1-1.19 1.191H1.19A1.19 1.19 0 0 1 0 15.605v-6.16c0-.657.533-1.19 1.19-1.19h37.62c.657 0 1.19.533 1.19 1.19z",
    fill: "#FFC73B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.64 11.086a34.533 34.533 0 0 0-3.99 5.709H6.538a41.882 41.882 0 0 1 6.596-10.454l2.22 1.914.344.296 2.622 2.26.32.275zM30.744 16.795h-8.113a34.67 34.67 0 0 0-3.991-5.709l.32-.275 2.623-2.26.344-.296 2.22-1.914a40.256 40.256 0 0 1 1.55 1.914 41.952 41.952 0 0 1 5.047 8.54z",
    fill: "#EFB025"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FF4440"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11.087a34.55 34.55 0 0 0-3.306 4.538 34.743 34.743 0 0 0-4.734 13.088 34.931 34.931 0 0 1-2.822-4.406 36.664 36.664 0 0 0-4.37 3.352 42.023 42.023 0 0 1 9.724-21.318l2.565 2.21 2.622 2.26.32.276zM35.231 27.659a36.664 36.664 0 0 0-4.37-3.352 34.931 34.931 0 0 1-2.821 4.406A34.738 34.738 0 0 0 20 11.087c.106-.092.212-.184.32-.275.874-.754 1.748-1.508 2.622-2.26.855-.738 1.71-1.474 2.565-2.21a41.913 41.913 0 0 1 5.04 7.29 42.035 42.035 0 0 1 4.684 14.027z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.815 11.087h6.37v5.708h-6.37z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m30.547 13.63-7.241 1.995a34.642 34.642 0 0 0-2.542-3.618l-.444-1.195L20 9.95l2.942-1.398 3.16-1.503a41.913 41.913 0 0 1 4.445 6.582zM20 9.95l-.32.862-.444 1.195a34.55 34.55 0 0 0-2.542 3.618l-7.24-1.994a41.91 41.91 0 0 1 4.443-6.581l3.16 1.502L20 9.95z",
    fill: "#EA2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.556.277 20 5.769l2.22 5.974 12.334-3.398A2.854 2.854 0 0 0 36.47 4.6L35.452 1.86A2.851 2.851 0 0 0 31.556.277zM8.444.277 20 5.769l-2.22 5.974L5.446 8.345A2.854 2.854 0 0 1 3.529 4.6L4.547 1.86A2.851 2.851 0 0 1 8.444.277z",
    fill: "#FF4440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.76 8.17a.637.637 0 0 1-.344-1.174c.087-.057 2.168-1.382 4.558-2.35 3.444-1.393 5.745-1.319 6.836.223a.637.637 0 0 1-1.04.737c-1.479-2.09-7.63 1.16-9.668 2.463a.634.634 0 0 1-.343.1zM17.177 8.17a.634.634 0 0 1-.342-.1c-2.038-1.304-8.19-4.554-9.67-2.464a.637.637 0 1 1-1.039-.737c1.092-1.542 3.392-1.616 6.837-.222 2.39.967 4.47 2.292 4.558 2.348a.638.638 0 0 1-.344 1.174z",
    fill: "#EA2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.812 3.715h-3.624c-.992 0-1.796.805-1.796 1.798v5.268c0 .993.804 1.798 1.796 1.798h3.624c.992 0 1.796-.805 1.796-1.798V5.513c0-.993-.804-1.798-1.796-1.798z",
    fill: "#EA2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4440",
    d: "M16.815 16.795h6.37V40h-6.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA2F2F",
    d: "M16.815 16.795h6.37V19.6h-6.37z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnclaimedRewards);
export default __webpack_public_path__ + "static/media/unclaimedRewards.95801fc7.svg";
export { ForwardRef as ReactComponent };